import { render, staticRenderFns } from "./SimulatorTopBar.vue?vue&type=template&id=4154fbb4&scoped=true&"
import script from "./SimulatorTopBar.vue?vue&type=script&lang=js&"
export * from "./SimulatorTopBar.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorTopBar.vue?vue&type=style&index=0&id=4154fbb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4154fbb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VSpacer,VToolbar,VTooltip})
